<template>
  <b-row>
    <b-col cols="12" xl="12">
      <!-- <transition name="slide"> -->
         <div id='loadingmessage' style="text-align:center;margin: 0px; padding: 0px; position: fixed; right: 0px; top: 0px; width: 100%; height: 100%; background-color: white; z-index: 30001; opacity: 0.8;" v-if="loading">
    <p style="position: absolute; color: White; top: 40%; left: 50%;">
      <img src='../assets/loader.gif'/>
    </p>
  </div>
      <b-card>
        <div slot="header">Report Generations
             <div v-if="items.length > 0" style="float:right;">
              <a style="padding-left:5px;padding-right:5px;">Total records found: {{items.length}}</a>
                <download-excel
                  class="btn btn-success btn-sm"
                  :data="items"
                  :fields="json_fields"
                  name="filename.xls"
                >
                  Download as Excel
                </download-excel>
              </div>
        </div>
        <b-form-group
          label="Please select the main filter criterias for search"
          style="color:rgb(243, 6, 17);font-size:14px;"
        >
          <b-form-checkbox-group
            id="checkbox-group-1"
            v-model="selected"
            :options="options"
            name="flavour-1"
          ></b-form-checkbox-group>
        </b-form-group>
        <div class="row" v-if="btn == 1" v-cloak>
          <div class="col-md-2" v-if="tprd=='tprd'">
            <div class="form-group label-floating">
              <label class="control-label">From</label>
              <input type="date" class="form-control" required v-model="from" />
            </div>
          </div>
          <div class="col-md-2" v-if="tprd=='tprd'">
            <div class="form-group label-floating">
              <label class="control-label">To</label>
              <input type="date" class="form-control" required v-model="to" />
            </div>
          </div>
           <div class="col-md-3" v-if="status =='status'">
            <div class="form-group label-floating">
              <label class="control-label">Choose Status</label>
               <select v-model="donationstatus" class="form-control" id="exampleFormControlSelect2">
      <option value="success">Success</option>
      <option value="failure">Failure</option>
      <option value="processing">Progress</option>
    </select>
            </div>
          </div>
           <div class="col-md-3" v-if="pgat =='pgat'">
            <div class="form-group label-floating">
              <label class="control-label">Choose Payment Gateway</label>
               <select v-model="paymentgateway" class="form-control" id="exampleFormControlSelect2">
      <option value="ccavenue">CCAvenue</option>
      <option value="payumoney">PayU Money</option>
    </select>
            </div>
          </div>
          <div class="col-md-2">
            <div class="form-group label-floating" style="padding-top:25px;">
              <label class="control-label"></label>
              <button
                id="btns"
                class="btn btn-success"
                @click="getData"
                v-if="btn==1 && to != '' || donationstatus != '' || paymentgateway != ''"
              >Submit</button>
            </div>
          </div>
        </div>
        <div v-else></div>
         <div class="table-responsive">
        <b-table
          :hover="hover"
          :striped="striped"
          :bordered="bordered"
          :small="small"
          :fixed="fixed"
          responsive="sm"
          :items="items"
          :fields="fields"
          :current-page="currentPage"
          :per-page="perPage"
          @row-clicked="rowClicked"
          class="table-responsive"
        >
          <template slot="firstname" slot-scope="data">
            <p>{{data.item.firstname}} {{data.item.lastname}}</p>
          </template>
           <template slot="init_date" slot-scope="data">
            <p>{{data.item.init_date | Date}}</p>
          </template>
          <template slot="payment_status" slot-scope="data">
            <b-badge :variant="getBadge(data.item.payment_status)">{{data.item.payment_status}}</b-badge>
          </template>
        </b-table>
         </div>
        <nav>
          <b-pagination
            size="sm"
            :total-rows="getRowCount(items)"
            :per-page="perPage"
            v-model="currentPage"
            prev-text="Prev"
            next-text="Next"
            hide-goto-end-buttons
          />
        </nav>
      </b-card>
      <!-- </transition> -->
    </b-col>
  </b-row>
</template>

<script>
import axios from "axios";
export default {
  name: "Users",
  props: {
    caption: {
      type: String,
      default: "Report Generations"
    },
    hover: {
      type: Boolean,
      default: true
    },
    striped: {
      type: Boolean,
      default: true
    },
    bordered: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    fixed: {
      type: Boolean,
      default: false
    }
  },
  data: () => {
    return {
      items: [],
      fields: [
        { key: "firstname",
        label: "Name" },
        { key: "email" },
        { key: "init_date",
        label: "Date" },
        { key: "amount" },
        { key: "donationtype" },
        { key: "payment_status" }
      ],
      currentPage: 1,
      perPage: 20,
      totalRows: 0,
      options: [
        {
          text: "Time Period",
          value: "tprd"
        },
        {
          text: "Status",
          value: "status"
        },
        {
          text: "Payment Gateway",
          value: "pgat"
        }
      ],
      json_fields: {
        Firstname: "firstname",
        Lastname: "lastname",
        Email: "email",
        Mobile: "mobile",
        Address: "address",
        City: "city",
        Country: "country",
        Date: "init_date",
        Amount: "amount",
        DonationType: "donationtype",
        Status: "payment_status",
        PostalCode: "postalcode",
        Region: "region",
        State: "state",
        TransactionID: "txnid",
      },
      json_data: [],
      json_meta: [
        [
          {
            key: "charset",
            value: "utf-8"
          }
        ]
      ],
      selected: [],
      btn: "",
      from: "",
      to: "",
      tprd: "",
      loading: false,
      donationstatus: '',
      paymentgateway: '',
      pgat:"",
    };
  },
  filters: {
        Date(value) {
              return value.slice(0,10);
        },
    },
  watch: {
    selected: function() {
      var vm = this;
      var sel = this.selected;
      var i = 0;
      if (sel.indexOf("tprd") >= 0) {
        vm.tprd = "tprd";
        i++;
        vm.btn = 1;
      } else {
        vm.tprd = "";
        vm.from = "";
        vm.to = "";
      }
       if (sel.indexOf("status") >= 0) {
        vm.status = "status";
        i++;
        vm.btn = 1;
      } else {
        vm.status = "";
        vm.donationstatus = "";
      }
        if (sel.indexOf("pgat") >= 0) {
        vm.pgat = "pgat";
        i++;
        vm.btn = 1;
      } else {
        vm.pgat = "";
        vm.paymentgateway = "";
      }
    }
  },
  mounted: function() {
      
  },
  methods: {
    getData() {
      this.loading = true;
      var data = {};
      if (this.from != "") data["fromDate"] = this.from;
      if (this.to != "") data["toDate"] = this.to;
      if (this.donationstatus != "") data["status"] = this.donationstatus;
      if(this.paymentgateway != "") data["paymentgateway"] = this.paymentgateway;
      axios({
        url: "https://wtiadmin.in/Donation/all",
        method: "POST",
        data: data
      })
        .then(response => {
          this.items = response.data.data;
          this.loading = false;
        })
        .catch(e => {
          this.loading = false;
          this.errors.push(e);
        });
    },
    getBadge(status) {
      return status === "sucess"
        ? "success"
        : status === "initiate"
        ? "secondary"
        : status === "progress"
        ? "warning"
        : status === "failure"
        ? "danger"
        : "primary";
    },
    getRowCount(items) {
      return items.length;
    },
    userLink(id) {
      return `users/${id.toString()}`;
    },
    rowClicked(item) {
      const userLink = this.userLink(item._id);
      this.$router.push({ path: userLink });
    }
  }
};
</script>

<style scoped>
.card-body >>> table > tbody > tr > td {
  cursor: pointer;
}
</style>